import {useState, useRef, useEffect} from "react";
import { Auth } from 'aws-amplify';
import './index.css';
import {Button,} from '@aws-amplify/ui-react';

import FormQuestion from '../form-question/index';

const Form = (userEmail) => {

  //const USER_BRANCH = process.env.USER_BRANCH;
  const REACT_BUILD_ENV = process.env.REACT_APP_BUILD_ENV;

  console.log("load test");
  console.log(`Current env: ${REACT_BUILD_ENV}`);

  const [startMessage, setStartMessage] = useState(
    ""
  );
    const [formQuestion, setformQuestion] = useState({
      question: "",
    });

    



    //hooks using useState for access to states
    const [formInfo, setformInfo] = useState({
      userName: "",
      email: userEmail.userEmail,
      message: "",
      question: "",
      /*userName: userName.userName,
      email: userEmail.userEmail,
      message: message.message,*/
      //question: question.question,
    });

        //get user token
        const getToken = async () => {
          const user = await Auth.currentAuthenticatedUser();
          const token = user.signInUserSession.idToken.jwtToken;
          console.log("token: ", token);
          return token;
          };
      

    async function getDbUser(url=""){

      let myHeaders = new Headers();
      //myHeaders.append('Accept', 'application/json');
      myHeaders.append("Content-Type", "application/json");
      let userTok = await getToken();
      console.log("userTok: " + userTok);
      myHeaders.append("Authorization",userTok);
     // var raw = data;
  
      var requestOptions = {
        method: 'GET',
       // mode: "no-cors",
        headers: myHeaders,
        //body: raw,
        redirect: 'follow'
      };
  
    const respDb= await  fetch(url, requestOptions)
   .then(response => 
     response.json()  )
  .catch(error => {throw new Error(error)}
    //console.log('error' ,error)
  
  );
  
  return respDb;
  
  };

    const getUser=  ()=>{
      console.log("in getUser");
      setStartMessage("Checking for user data...");    

       getDbUser(`https://fkhlbp11e2.execute-api.ca-central-1.amazonaws.com/${REACT_BUILD_ENV}/updatedb?email=`+ 
       userEmail.userEmail).then((data)=> {
        console.log(data); 
        //console.log(data.message); 
        //console.log(data.name); 

     setformQuestion({
             question: data.question
          });
      setformInfo({

      userName: data.name,
      email: userEmail.userEmail,
      message: data.message,
      question: data.question

         });

         setStartMessage("*User data loaded successfully*");  
         
         
       }).catch((error)=>{
        setStartMessage("*No previous user data found*");
        console.log(error);
       }
       );
   }






    const onChange = (e) => {
      //spread to use all of our values
      //with key value pair
      setformInfo({...formInfo,[e.target.id]:e.target.value});
      
      //for formQuestion:
      setformQuestion({...formQuestion,[e.target.id]:e.target.value});

      console.log(e.target.value);

    };



    async function postMessage(url="",data={}){

      setStartMessage("Sending email...");   

      let myHeaders = new Headers();
      //myHeaders.append('Accept', 'application/json');
      myHeaders.append("Content-Type", "application/json");
      let userTok = await getToken();
      //console.log("userTok: " + userTok);
      myHeaders.append("Authorization",userTok);
     /* myHeaders.append("Access-Control-Allow-Origin","*");
     myHeaders.append("Access-Control-Allow-Credentials","true");*/
     
      var raw = data;

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        //mode: "no-cors",
        body: raw,
        //body:"test",
        redirect: 'follow'
      };

    const respEmail= await  fetch(url, requestOptions)
   .then(response => response.json()
  )
  .catch(error => 
    console.log('error' ,error)
    //alert("Email Failed to Send")
  );
  

   return respEmail;

  };

  async function updateDb(url="",data={}){

    setStartMessage("Saving details...");   

    let myHeaders = new Headers();
    //myHeaders.append('Accept', 'application/json');
    myHeaders.append("Content-Type", "application/json");
    let userTok = await getToken();
    //console.log("userTok: " + userTok);
    myHeaders.append("Authorization",userTok);
    var raw = data;

    var requestOptions = {
      method: 'POST',
     // mode: "no-cors",
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

  const respDb= await  fetch(url, requestOptions)
 .then(response => response.json())
.catch(error => 
  console.log('error' ,error)
 // alert("Dtabase Updated Failed");
);


 return respDb;

};
    
    const  onSubmit =  (e) => {
      e.preventDefault();
      console.log(formInfo);
      console.log(formQuestion1);
      //console.log(formQuestion1.props);
     // console.log(formQuestion1.props.value);
      //setformInfo(formInfo.question,{[formInfo.question]:formQuestion1.question});


     let msg = JSON.stringify({
        "to": userEmail.userEmail,
        "from": "corronzo.developer@gmail.com",
        "message" : JSON.stringify(formInfo)
       // "message": "this is a test from react form"
      });
                  //"https://fkhlbp11e2.execute-api.ca-central-1.amazonaws.com/Beta5"
      postMessage(`https://fkhlbp11e2.execute-api.ca-central-1.amazonaws.com/${REACT_BUILD_ENV}`, msg).then((data)=> {
      console.log(data);
      console.log(data.$metadata.httpStatusCode);
      if (data.$metadata.httpStatusCode !== 200){
        console.log("email did not send");
        alert("email did not send");
        setStartMessage("*Confirmation email unable to be sent*");
      }else{
        console.log("email sent successfully");
        setStartMessage("*Confirmation email sent*");
      }
   //   alert("email sent");
    });

    let formDetails = JSON.stringify({
      "email": formInfo.email,
      "name": formInfo.userName,
      "message": formInfo.message,
      "question":formInfo.question
    });
      updateDb(`https://fkhlbp11e2.execute-api.ca-central-1.amazonaws.com/${REACT_BUILD_ENV}/updatedb`, formDetails).then((data)=> {
        //console.log(data);
        console.log(`Put item ${formInfo.email}`);
        if (data !== `Put item ${formInfo.email}`){
          console.log("db did not update");
          alert("*unable to save data*");
        }else{
          console.log("db updated");
        }
      });
    }

  //onSave
  const onSave = () => {
    //e.preventDefault();
    console.log(formInfo);
    console.log(formQuestion1);
    setStartMessage("Saving details...");   

    let formDetails = JSON.stringify({
      "email": formInfo.email,
      "name": formInfo.userName,
      "message": formInfo.message,
      "question":formInfo.question
    });
      updateDb(`https://fkhlbp11e2.execute-api.ca-central-1.amazonaws.com/${REACT_BUILD_ENV}/updatedb`, formDetails).then((data)=> {
        console.log(data);
        console.log(`Put item ${formInfo.email}`);
        if (data !== `Put item ${formInfo.email}`){
          console.log("Form could not be saved");
          alert("Form could not be saved");
        }else{
          console.log("save updated");
          setStartMessage("*Form saved*");
        }
      });
    }

    //onClear
  const onClear = () => {
    setformInfo({

       userName: "",
       email: userEmail.userEmail,
       message: "",
       question: ""
 
          });
    setformQuestion({
            question: ""
         });
    setStartMessage("*Form cleared*");


   
    }

      //adding state variable and function to child component
      const formQuestion1 = <FormQuestion 
      id="question" 
      value={formQuestion.question}
      onChange={onChange}
    />

    useEffect(()=>{
      //console.log("in useEffect");
      getUser();
      return ()=>{
 
      }
     },[]);



     

  return (   
    <form id="finalForm1" type="HTMLFormElement" onSubmit={onSubmit}>
 
    <h3>{startMessage}</h3>
    <div id="formone">
    <h3>Sec #1 (Mandatory)</h3>
    <label>
      Full Name:
      <input 
      type="text" 
      id="userName" 
      name="user_name"  
      placeholder="Full Name" 
      value={formInfo.userName}
      onChange={onChange} />
    </label>

    <label>
      Email(Pulled From Login):
      <input 
      type="text" 
      id="email" 
      name="user_email" 
      placeholder="email" 
      value={formInfo.email}
      disabled={true}
      onChange={onChange} />
    </label>

    </div>

    <div id="formtwo" >
    <h3>Sec #2 (Mandatory) - Complete Sec #1</h3>
    <label
    hidden ={!formInfo.userName || !formInfo.email}>
      Message:
    </label>
    <textarea
    hidden ={!formInfo.userName || !formInfo.email}
    type="text"
    id="message"
    name="message"
    placeholder="How did you find us?"
    value={formInfo.message}
    onChange={onChange}></textarea>   
    <br hidden={!formInfo.userName || !formInfo.email}></br> 
    <br hidden={!formInfo.userName || !formInfo.email}></br>
    </div>

    <div id="formtwo">
    <h3>Sec #3 (Optional) - Complete Sec #2</h3>
    <label
    hidden ={!formInfo.userName || !formInfo.email || !formInfo.message }>
            Question:
    </label>
    {(formInfo.userName && formInfo.email && formInfo.message) && formQuestion1} 
    <br hidden={!formInfo.userName || !formInfo.email || !formInfo.message}></br> 
    <br hidden={!formInfo.userName || !formInfo.email || !formInfo.message}></br>
    </div>

    <h3>{startMessage}</h3>

    <div >
    <span>

    <Button 
    id="button-margin"
    variation="primary" 
    disabled={!formInfo.userName || !formInfo.email}
    onClick={onSave}>Save</Button>

    <Button 
    id="button-margin"
    variation="primary" 
    onClick={onClear}>Clear</Button>
    </span>
    </div>

    <Button 
    variation="primary" 
    disabled={!formInfo.userName || !formInfo.email || !formInfo.message}  
    type="submit" 
    value="Submit"  >Submit</Button>
   
  </form>
);

};

export default Form;